import { defineMessages } from 'react-intl';

export default defineMessages({
    yesModal: {
        "id": "quoteandbind.residential.additionalInsured.Yes",
        "defaultMessage": "Yes"
    },
    noModal: {
        "id": "quoteandbind.residential.additionalInsured.No",
        "defaultMessage": "No"
    },
    saveFailedMsg: {
        id: 'quoteandbind.residential.additionalInsured.Save failed',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'quoteandbind.residential.additionalInsured.Cannot Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },
    cancel: {
        "id": "quoteandbind.residential.additionalInsured.Cancel",
        "defaultMessage": "Cancel"
    },
    removeAdditionalInsured: {
        "id": "quoteandbind.residential.additionalInsured.Remove Additional Interest",
        "defaultMessage": "Remove Additional Named Insured"
    },
    removeAddlInsuredMessage: {
        "id": "quoteandbind.residential.additionalInsured.Are you sure you want to remove this contact?",
        "defaultMessage": "Are you sure you want to remove this contact?"
    },

});
